import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';

import { Section } from 'jbc-front/components/Form';

import { INHABITANT_TAX_COLLECTION_METHODS, INHABITANT_TAX_MONTH_SETTING_TYPE } from 'src/constants/Options';
import { getOptionLabel, numberWithComma, display } from 'src/utils/Utils';
import { withTranslation } from 'react-i18next';

import { annualInhabitantTaxOfSimple, annualInhabitantTaxOfMonth } from '../inhabitantTaxCommon';

import styles from './InhabitantTaxSectionShow.scss';
import tableStyles from '../styles/GeneralTableInfo.scss';

const getNextMonthOfLandmark = landmarkMonth => {
  if (!landmarkMonth) return undefined;

  return +landmarkMonth % 12 + 1;
};

const getCityCode = (prefectureId, cityId, cities) => {
  const city = _.find(_.get(cities, prefectureId, []), { id: cityId });
  return _.get(city, 'organizationCode', '');
};



class InhabitantTaxSectionShow extends React.Component {
  render() {
    const { t, employeeInhabitantTax, prefectures, cities } = this.props;
    
    return (
      <div>
        <Section title={t('features.Employees.components.InhabitantTax.city_payment_destination.title')}>
          <table className={tableStyles.mTablePersonal}>
            <tbody>
              <tr>
                <th>{t('features.Employees.components.InhabitantTax.city_payment_destination.component.province')}：</th>
                <td>{display(getOptionLabel(employeeInhabitantTax.payeePrefectureId)(prefectures))}</td>
              </tr>
              {cities && (
                <tr>
                  <th>{t('features.Employees.components.InhabitantTax.city_payment_destination.component.city')}：</th>
                  <td>
                    {cities &&
                      display(
                        getOptionLabel(employeeInhabitantTax.payeeCityId)(
                          cities[employeeInhabitantTax.payeePrefectureId]
                        )
                      )}
                  </td>
                </tr>
              )}
              {cities && (
                <tr>
                  <th>{t('features.Employees.components.InhabitantTax.city_payment_destination.component.city_code')}：</th>
                  <td>
                    {display(
                      getCityCode(employeeInhabitantTax.payeePrefectureId, employeeInhabitantTax.payeeCityId, cities)
                    )}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </Section>
        <Section title={t('features.Employees.components.InhabitantTax.salary_payment_report.title')}>
          <table className={tableStyles.mTablePersonal}>
            <tbody>
              <tr>
                <th>{t('features.Employees.components.InhabitantTax.salary_payment_report.component.province')}：</th>
                <td>{display(getOptionLabel(employeeInhabitantTax.reportSubmissionPrefectureId)(prefectures))}</td>
              </tr>
              <tr>
                <th>{t('features.Employees.components.InhabitantTax.salary_payment_report.component.city')}：</th>
                <td>
                  {cities &&
                    display(
                      getOptionLabel(employeeInhabitantTax.reportSubmissionCityId)(
                        cities[employeeInhabitantTax.reportSubmissionPrefectureId]
                      )
                    )}
                </td>
              </tr>
              <tr>
                <th>{t('features.Employees.components.InhabitantTax.salary_payment_report.component.city_code')}：</th>
                <td>
                  {display(
                    getCityCode(
                      employeeInhabitantTax.reportSubmissionPrefectureId,
                      employeeInhabitantTax.reportSubmissionCityId,
                      cities
                    )
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </Section>
        <Section title={t('features.Employees.components.InhabitantTax.amount_of_money.title')}>
          <table className={tableStyles.mTablePersonal}>
            <tbody>
              <tr>
                <th>{t('features.Employees.components.InhabitantTax.amount_of_money.component.resident_tax_collection_method')}：</th>
                <td>
                  {display(getOptionLabel(employeeInhabitantTax.collectionMethod)(INHABITANT_TAX_COLLECTION_METHODS))}
                </td>
              </tr>
              {employeeInhabitantTax.collectionMethod === 'special' && (
                <React.Fragment>
                  <tr>
                    <th>{t('features.Employees.components.InhabitantTax.amount_of_money.component.tax_month_setting_type')}：</th>
                    <td>
                      {display(
                        getOptionLabel(employeeInhabitantTax.monthSettingType)(INHABITANT_TAX_MONTH_SETTING_TYPE)
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th />
                    {/* thとtdのtopにborderがスタイルされているためスタイル調整のために空のリストを入れる */}
                    <td />
                  </tr>
                </React.Fragment>
              )}
            </tbody>
          </table>
          {employeeInhabitantTax.collectionMethod === 'special' && this.renderTaxAmounts()}
        </Section>
      </div>
    );
  }

  // 住民税額の描画
  renderTaxAmounts = () => {
    const { employeeInhabitantTax } = this.props;
    return employeeInhabitantTax.monthSettingType === 'simple'
      ? this.renderTaxAmountsSimple()
      : this.renderTaxAmountsMonth();
  };

  // 住民税額の描画(簡易設定)
  renderTaxAmountsSimple = () => {
    const { t, employeeInhabitantTax, taxAmountLandmark, taxAmountAfterLandmark } = this.props;
    return (
      <table className={tableStyles.mTablePersonal}>
        <tbody>
          {/* <tr>
            <th>{employeeInhabitantTax.landmarkMonth}月の住民税：</th>
            <td>{numberWithComma(taxAmountLandmark)}円</td>
          </tr>
          <tr>
            <th>{getNextMonthOfLandmark(employeeInhabitantTax.landmarkMonth)}月以降の住民税：</th>
            <td>{numberWithComma(taxAmountAfterLandmark)}円</td>
          </tr> */}
          <tr>
            <th>{t('features.Employees.components.InhabitantTax.amount_of_money.component.annual_tax_amount')}：</th>
            <td>
              {display(
                annualInhabitantTaxOfSimple(
                  employeeInhabitantTax.landmarkMonth,
                  taxAmountLandmark,
                  taxAmountAfterLandmark
                )
              )}
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  // 住民税額の描画(月別設定)
  renderTaxAmountsMonth = () => {
    const { taxAmounts } = this.props;
    const leftMonthAmounts = [6, 7, 8, 9, 10, 11].map(month => _.find(taxAmounts, ta => ta.month === month));
    const rightMonthAmounts = [12, 1, 2, 3, 4, 5].map(month => _.find(taxAmounts, ta => ta.month === month));
    return (
      <div>
        <div className={styles.taxAmounts}>
          <div className={styles.taxAmountsColumn}>{leftMonthAmounts.map(amount => this.renderAmount(amount))}</div>
          <div className={classNames(styles.taxAmountsColumn, 'u-ml40')}>
            {rightMonthAmounts.map(amount => this.renderAmount(amount))}
          </div>
        </div>
        <table className={tableStyles.mTablePersonal}>
          <tbody>
            <tr>
              <th />
              {/* thとtdのtopのborderは先頭行には適用されないため、スタイル調整のために先頭に空行を入れる */}
              <td />
            </tr>
            <tr>
              <th>年税額：</th>
              <td>{display(annualInhabitantTaxOfMonth(taxAmounts))}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  renderAmount = taxAmount => (
    <div key={taxAmount.month} className={styles.taxAmountsCell}>
      <div>{taxAmount.month}月</div>
      <div>{numberWithComma(taxAmount.amount)}円</div>
    </div>
  );
}

export default withTranslation()(InhabitantTaxSectionShow);
